// 多语言翻译文件
export const translations = {
  zh: {
    // 导航栏
    nav: {
      home: '首页',
      collection: '系列',
      shop: 'Shop',
      about: '关于',
      contact: '联系',
      cart: '购物车'
    },
    home: {
      hero: {
        kicker: 'JuMel / Sterling Silver Objects',
        title: 'Wear your own definition.',
        subtitle: 'JuMel 不定义任何人，只做你的配件。纯银贴近身体，不解释性别、职业、年龄或来处；它只是安静地留下一个位置，让你自己决定意义。',
        image: '/products/signal/IMG_6316-web.jpg',
        imageAlt: 'JuMel 纯银戒指佩戴图',
        specLabel: 'JuMel 品牌关键词',
        specs: ['STERLING SILVER ONLY', 'WEAR YOUR OWN DEFINITION'],
        shopCta: '进入商店',
        collectionCta: '查看系列'
      },
      collection: {
        kicker: 'Series language',
        title: '银色以结构开口。',
        note: 'STERLING SILVER ONLY / UNDEFINED BY DESIGN',
        items: [
          {
            code: 'STREAM_01',
            title: 'STREAM',
            concept: 'movement held in silver',
            subtitle: '弧面、波浪和连续线条被压进一枚戒指里。它随手部动作改变光线，像一条不愿停在单一定义里的轨迹。',
            image: '/products/streamline/IMG_5377-web.jpg',
            alt: 'JuMel STREAM 纯银戒指'
          },
          {
            code: 'CHAIN_01',
            title: 'CHAIN',
            concept: 'connection without a lock',
            subtitle: '链条可以连接，也可以保留空隙。JuMel 的 CHAIN 不把关系锁死，让结构在日常里继续移动。',
            image: '/products/chain/IMG_8075-web.jpg',
            alt: 'JuMel CHAIN 纯银链条戒指'
          },
          {
            code: 'SIGNAL_01',
            title: 'SIGNAL',
            concept: 'a quiet mark',
            subtitle: '打结、断点、微小标记。SIGNAL 不把态度喊出来，只把它留在手上，成为只属于佩戴者的暗号。',
            image: '/products/signal/IMG_5439-web.jpg',
            alt: 'JuMel SIGNAL 纯银戒指'
          }
        ]
      },
      productView: {
        kicker: 'Selected objects',
        title: '让银色先靠近身体。',
        ariaLabel: 'JuMel 产品展示',
        items: [
          {
            code: 'JM_STREAM',
            image: '/products/streamline/IMG_5428-web.jpg',
            alt: 'JuMel 宽面纯银戒指佩戴图'
          },
          {
            code: 'JM_CHAIN',
            image: '/products/chain/IMG_8083-web.jpg',
            alt: 'JuMel 纯银链条戒指'
          },
          {
            code: 'JM_SIGNAL',
            image: '/products/signal/IMG_5439-web.jpg',
            alt: 'JuMel 打结纯银戒指佩戴图'
          },
          {
            code: 'JM_OBJECT',
            image: '/products/streamline/IMG_5481-web.jpg',
            alt: 'JuMel 极简纯银戒指佩戴图'
          }
        ]
      },
      philosophy: {
        kicker: 'Brand story',
        title: '不被定义，也不必离开系统。',
        description: 'JuMel 从女性工程师的结构直觉出发。链条、节点、边界和可活动的形体，不是为了制造坚硬的态度，而是让人在既有规则里仍有自己的余地。它不替你反抗，也不替你说明；它只是每天留在手上，提醒你不必被任何答案收束。',
        image: '/products/signal/IMG_6316-web.jpg',
        imageAlt: 'JuMel 纯银戒指品牌故事图',
        points: ['STERLING SILVER ONLY', 'GENDERLESS', 'ENGINEERED STRUCTURE', 'DAILY OBJECT']
      },
      shopify: {
        kicker: 'Sterling silver only',
        title: '只做纯银饰。',
        description: '不是甜美的符号，不是性别的标签。JuMel 把首饰留在最接近身体的位置，像一个清晰、冷静、可佩戴的结构。',
        cta: '进入商店',
        url: 'https://jumel-accessory.myshopify.com'
      }
    },
    // Hero 区域
    hero: {
      title: '纯银之美，匠心之作',
      subtitle: 'JuMel - 每一枚戒指，都是艺术与科技的完美融合',
      cta: '探索系列',
      placeholder: '精美银戒指大图'
    },
    // AI 功能区
    ai: {
      title: 'AI 赋能的银饰美学',
      subtitle: '融合人工智能与传统工艺，为您呈现独一无二的银饰体验',
      features: {
        design: {
          title: '智能设计',
          description: 'AI 辅助设计系统，精准捕捉每一个细节，让每件作品都散发独特光芒'
        },
        pricing: {
          title: '智能定价',
          description: '实时市场分析，确保您获得最具性价比的高品质银饰，透明公正'
        },
        experience: {
          title: '极速体验',
          description: '从浏览到下单，流畅如丝的购物体验，M4 芯片加持，每一帧都是享受'
        },
        collection: {
          title: '精选系列',
          description: '每一款银戒指都经过严格筛选，只为呈现最纯粹的银饰之美'
        }
      }
    },
    // 品牌故事
    story: {
      title: 'JuMel 的故事',
      paragraph1: 'JuMel，源自对纯银之美的极致追求。我们相信，每一枚戒指都承载着独特的故事，每一次佩戴都是对美好时刻的纪念。',
      paragraph2: '通过 AI 技术与传统工艺的完美结合，我们为每一位顾客提供个性化的银饰体验，让科技赋能美学，让艺术触手可及。',
      placeholder: '品牌故事图片'
    },
    // 页脚
    footer: {
      tagline: 'Wear your own definition.',
      products: {
        title: '产品',
        rings: '戒指系列',
        new: '新品上市',
        custom: '定制服务'
      },
      about: {
        title: '关于',
        story: '品牌故事',
        craft: '工艺介绍',
        contact: '联系我们'
      },
      service: {
        title: '服务',
        shipping: '配送信息',
        returns: '退换政策',
        care: '保养指南'
      },
      copyright: '© 2026 JuMel. All rights reserved.'
    },
    // 产品详情页
    product: {
      productCode: '产品编号',
      productName: 'JuMel 纯银戒指系列',
      description: '产品描述',
      descriptionText: '精选 925 纯银打造，经过 AI 辅助设计与传统工艺的完美结合。每一枚戒指都经过严格的质量检测，确保您获得最纯粹的银饰之美。',
      features: {
        material: '925 纯银材质',
        design: 'AI 智能设计',
        craft: '手工精细打磨',
        warranty: '终身售后保障'
      },
      size: '尺寸',
      addToCart: '加入购物车',
      relatedProducts: '相关推荐',
      productFeatures: {
        shipping: { title: '免费配送', desc: '全国包邮' },
        returns: { title: '7天退换', desc: '无理由退换货' },
        authentic: { title: '正品保证', desc: '100% 纯银' }
      }
    },
    // 购物车
    cart: {
      title: '购物车',
      empty: '购物车是空的',
      continueShopping: '继续购物',
      checkout: '去结算',
      total: '总计',
      quantity: '数量',
      remove: '删除',
      successAdded: '成功加入购物车！',
      viewCart: '查看购物车'
    }
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      collection: 'Collection',
      shop: 'Shop',
      about: 'About',
      contact: 'Contact',
      cart: 'Cart'
    },
    home: {
      hero: {
        kicker: 'JuMel / Sterling Silver Objects',
        title: 'Wear your own definition.',
        subtitle: 'JuMel defines no one. It makes sterling silver pieces that stay close to the body without explaining gender, work, age, or origin. The meaning is left to the wearer.',
        image: '/products/signal/IMG_6316-web.jpg',
        imageAlt: 'JuMel sterling silver rings on hand',
        specLabel: 'JuMel brand keywords',
        specs: ['STERLING SILVER ONLY', 'WEAR YOUR OWN DEFINITION'],
        shopCta: 'Shop Collection',
        collectionCta: 'View Series'
      },
      collection: {
        kicker: 'Series language',
        title: 'Silver opens through structure.',
        note: 'STERLING SILVER ONLY / UNDEFINED BY DESIGN',
        items: [
          {
            code: 'STREAM_01',
            title: 'STREAM',
            concept: 'movement held in silver',
            subtitle: 'Curved planes, waves, and continuous lines are pressed into one ring. It changes with the hand, like a trace that refuses a single reading.',
            image: '/products/streamline/IMG_5377-web.jpg',
            alt: 'JuMel STREAM sterling silver ring'
          },
          {
            code: 'CHAIN_01',
            title: 'CHAIN',
            concept: 'connection without a lock',
            subtitle: 'A chain can connect without closing everything down. CHAIN keeps a little space inside the structure, so relation can still move.',
            image: '/products/chain/IMG_8075-web.jpg',
            alt: 'JuMel CHAIN sterling silver ring'
          },
          {
            code: 'SIGNAL_01',
            title: 'SIGNAL',
            concept: 'a quiet mark',
            subtitle: 'Knots, breaks, and small marks. SIGNAL does not raise its voice; it stays on the hand as a private code for the wearer.',
            image: '/products/signal/IMG_5439-web.jpg',
            alt: 'JuMel SIGNAL sterling silver ring'
          }
        ]
      },
      productView: {
        kicker: 'Selected objects',
        title: 'Let silver come close first.',
        ariaLabel: 'JuMel product view',
        items: [
          {
            code: 'JM_STREAM',
            image: '/products/streamline/IMG_5428-web.jpg',
            alt: 'JuMel wide sterling silver ring on hand'
          },
          {
            code: 'JM_CHAIN',
            image: '/products/chain/IMG_8083-web.jpg',
            alt: 'JuMel sterling silver chain rings'
          },
          {
            code: 'JM_SIGNAL',
            image: '/products/signal/IMG_5439-web.jpg',
            alt: 'JuMel knot sterling silver ring on hand'
          },
          {
            code: 'JM_OBJECT',
            image: '/products/streamline/IMG_5481-web.jpg',
            alt: 'JuMel minimal sterling silver ring on hand'
          }
        ]
      },
      philosophy: {
        kicker: 'Brand story',
        title: 'Undefined, even inside the system.',
        description: 'JuMel begins with a female engineer’s instinct for structure. Chains, nodes, borders, and moving forms are not built as loud rebellion; they are small spaces of agency inside existing systems. The piece does not explain you. It stays on the hand and reminds you that no fixed answer has to hold.',
        image: '/products/signal/IMG_6316-web.jpg',
        imageAlt: 'JuMel sterling silver brand image',
        points: ['STERLING SILVER ONLY', 'GENDERLESS', 'ENGINEERED STRUCTURE', 'DAILY OBJECT']
      },
      shopify: {
        kicker: 'Sterling silver only',
        title: 'Only sterling silver jewelry.',
        description: 'Not a sweet symbol. Not a gendered label. JuMel keeps jewelry close to the body as a clear, quiet, wearable structure.',
        cta: 'Shop Collection',
        url: 'https://jumel-accessory.myshopify.com'
      }
    },
    // Hero Section
    hero: {
      title: 'Silver with a point of view',
      subtitle: 'JuMel creates engineered silver jewelry for people who choose their own outline.',
      cta: 'Explore Collection',
      placeholder: 'Exquisite Silver Ring Image'
    },
    // AI Section
    ai: {
      title: 'Designed with precision, finished by hand',
      subtitle: 'Digital tools help shape the details. Human craft gives each piece its final tension and touch.',
      features: {
        design: {
          title: 'Measured detail',
          description: 'Digital design helps refine proportion, spacing, and structure before the piece reaches the hand.'
        },
        pricing: {
          title: 'Clear value',
          description: 'Materials, finish, and production are considered with transparency, so the price feels grounded.'
        },
        experience: {
          title: 'Smooth purchase',
          description: 'A direct path from browsing to checkout, with the focus kept on the piece itself.'
        },
        collection: {
          title: 'Edited collection',
          description: 'Each ring is selected for shape, weight, and presence rather than decoration alone.'
        }
      }
    },
    // Brand Story
    story: {
      title: 'The JuMel Story',
      paragraph1: 'JuMel grew from a fascination with silver as both material and signal. A ring can be small, but it can still change how the hand feels in the world.',
      paragraph2: 'By combining digital design with traditional finishing, JuMel creates pieces that feel precise without losing their human temperature.',
      placeholder: 'Brand Story Image'
    },
    // Footer
    footer: {
      tagline: 'Wear your own definition.',
      products: {
        title: 'Products',
        rings: 'Ring Collection',
        new: 'New Arrivals',
        custom: 'Custom Service'
      },
      about: {
        title: 'About',
        story: 'Brand Story',
        craft: 'Craftsmanship',
        contact: 'Contact Us'
      },
      service: {
        title: 'Service',
        shipping: 'Shipping Info',
        returns: 'Return Policy',
        care: 'Care Guide'
      },
      copyright: '© 2026 JuMel. All rights reserved.'
    },
    // Product Detail Page
    product: {
      productCode: 'Product Code',
      productName: 'JuMel Silver Ring Collection',
      description: 'Details',
      descriptionText: 'Made in 925 sterling silver, each JuMel ring balances engineered structure with hand-finished detail. The result is clean, wearable, and quietly assertive.',
      features: {
        material: '925 Sterling Silver',
        design: 'Digitally Refined Form',
        craft: 'Hand-Finished Surface',
        warranty: 'Aftercare Support'
      },
      size: 'Size',
      addToCart: 'Add to Cart',
      relatedProducts: 'Related Products',
      productFeatures: {
        shipping: { title: 'Free Shipping', desc: 'Available nationwide' },
        returns: { title: '7-Day Returns', desc: 'Simple return process' },
        authentic: { title: 'Sterling Silver', desc: '925 silver material' }
      }
    },
    // Shopping Cart
    cart: {
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      continueShopping: 'Continue Shopping',
      checkout: 'Checkout',
      total: 'Total',
      quantity: 'Quantity',
      remove: 'Remove',
      successAdded: 'Successfully added to cart!',
      viewCart: 'View Cart'
    }
  },
  ja: {
    // ナビゲーション
    nav: {
      home: 'ホーム',
      collection: 'コレクション',
      shop: 'Shop',
      about: '私たちについて',
      contact: 'お問い合わせ',
      cart: 'カート'
    },
    home: {
      hero: {
        kicker: 'JuMel / Sterling Silver Objects',
        title: 'Wear your own definition.',
        subtitle: 'JuMelは誰かを定義しません。純銀だけで、身体に近い静かなピースをつくります。性別、職業、年齢、出身を説明するためではなく、意味を身につける人に残すために。',
        image: '/products/signal/IMG_6316-web.jpg',
        imageAlt: 'JuMelの純銀リング着用写真',
        specLabel: 'JuMel ブランドキーワード',
        specs: ['STERLING SILVER ONLY', 'WEAR YOUR OWN DEFINITION'],
        shopCta: 'ショップへ',
        collectionCta: 'シリーズを見る'
      },
      collection: {
        kicker: 'Series language',
        title: 'シルバーは構造として開く。',
        note: 'STERLING SILVER ONLY / UNDEFINED BY DESIGN',
        items: [
          {
            code: 'STREAM_01',
            title: 'STREAM',
            concept: 'movement held in silver',
            subtitle: '曲面、波、連続する線をひとつのリングに閉じ込めました。手の動きとともに光を変え、ひとつの意味に留まらない軌跡になります。',
            image: '/products/streamline/IMG_5377-web.jpg',
            alt: 'JuMel STREAM 純銀リング'
          },
          {
            code: 'CHAIN_01',
            title: 'CHAIN',
            concept: 'connection without a lock',
            subtitle: 'チェーンはつなぐことも、余白を残すこともできます。CHAINは関係を閉じきらず、構造の中に動ける場所を残します。',
            image: '/products/chain/IMG_8075-web.jpg',
            alt: 'JuMel CHAIN 純銀チェーンリング'
          },
          {
            code: 'SIGNAL_01',
            title: 'SIGNAL',
            concept: 'a quiet mark',
            subtitle: '結び目、切れ目、小さな印。SIGNALは声を大きくしません。身につける人だけが意味を持てる、手元の暗号です。',
            image: '/products/signal/IMG_5439-web.jpg',
            alt: 'JuMel SIGNAL 純銀リング'
          }
        ]
      },
      productView: {
        kicker: 'Selected objects',
        title: 'まずシルバーを身体の近くへ。',
        ariaLabel: 'JuMelの商品ビュー',
        items: [
          {
            code: 'JM_STREAM',
            image: '/products/streamline/IMG_5428-web.jpg',
            alt: 'JuMel ワイド純銀リング着用写真'
          },
          {
            code: 'JM_CHAIN',
            image: '/products/chain/IMG_8083-web.jpg',
            alt: 'JuMel 純銀チェーンリング'
          },
          {
            code: 'JM_SIGNAL',
            image: '/products/signal/IMG_5439-web.jpg',
            alt: 'JuMel 結び目純銀リング着用写真'
          },
          {
            code: 'JM_OBJECT',
            image: '/products/streamline/IMG_5481-web.jpg',
            alt: 'JuMel ミニマル純銀リング着用写真'
          }
        ]
      },
      philosophy: {
        kicker: 'Brand story',
        title: '定義されず、システムの中にいる。',
        description: 'JuMelは、女性エンジニアの構造への直感から始まりました。チェーン、ノード、境界、動くかたちは、大きな反抗ではなく、決められた仕組みの中に残す小さな余地です。説明するためではなく、手元に残り、ひとつの答えに収まらなくていいことを思い出すために。',
        image: '/products/signal/IMG_6316-web.jpg',
        imageAlt: 'JuMelの純銀リングブランド写真',
        points: ['STERLING SILVER ONLY', 'GENDERLESS', 'ENGINEERED STRUCTURE', 'DAILY OBJECT']
      },
      shopify: {
        kicker: 'Sterling silver only',
        title: '純銀のジュエリーだけを。',
        description: '甘い記号ではなく、性別のラベルでもなく。JuMelは、身体に近い場所に残る、明確で静かなウェアラブルな構造をつくります。',
        cta: 'ショップへ',
        url: 'https://jumel-accessory.myshopify.com'
      }
    },
    // ヒーローセクション
    hero: {
      title: '輪郭を持ったシルバー',
      subtitle: 'JuMelは、自分のかたちを選ぶ人のためのエンジニアード・シルバージュエリーです。',
      cta: 'コレクションを見る',
      placeholder: '美しいシルバーリング画像'
    },
    // AIセクション
    ai: {
      title: '精密に設計し、手で仕上げる',
      subtitle: 'デジタルツールで細部を整え、最後の緊張感と手ざわりは人の手で仕上げます。',
      features: {
        design: {
          title: '測られたディテール',
          description: '比率、間隔、構造をデジタルで検討し、手に届く前のかたちを丁寧に整えます。'
        },
        pricing: {
          title: '納得できる価値',
          description: '素材、仕上げ、制作工程をきちんと見つめ、価格にも透明感を持たせます。'
        },
        experience: {
          title: '迷わない購入体験',
          description: '見る、選ぶ、購入する。その流れをシンプルに保ち、主役をジュエリーそのものに戻します。'
        },
        collection: {
          title: '編集されたコレクション',
          description: '装飾だけではなく、かたち、重さ、手元での存在感を基準に選んでいます。'
        }
      }
    },
    // ブランドストーリー
    story: {
      title: 'JuMelの物語',
      paragraph1: 'JuMelは、素材としてのシルバーと、サインとしてのシルバーへの関心から始まりました。小さなリングでも、手元と世界の関係を少し変えることができます。',
      paragraph2: 'デジタル設計と手仕事の仕上げを組み合わせることで、精密でありながら体温を失わないジュエリーをつくります。',
      placeholder: 'ブランドストーリー画像'
    },
    // フッター
    footer: {
      tagline: 'Wear your own definition.',
      products: {
        title: '製品',
        rings: 'リングコレクション',
        new: '新着',
        custom: 'カスタムサービス'
      },
      about: {
        title: '私たちについて',
        story: 'ブランドストーリー',
        craft: '職人技',
        contact: 'お問い合わせ'
      },
      service: {
        title: 'サービス',
        shipping: '配送情報',
        returns: '返品ポリシー',
        care: 'お手入れガイド'
      },
      copyright: '© 2026 JuMel. All rights reserved.'
    },
    // 商品詳細ページ
    product: {
      productCode: '商品番号',
      productName: 'JuMel シルバーリングコレクション',
      description: 'ディテール',
      descriptionText: '925スターリングシルバーを使用し、構造的なフォルムと手仕上げのディテールを両立させたJuMelのリング。クリーンで身につけやすく、静かな強さを持つ一点です。',
      features: {
        material: '925スターリングシルバー',
        design: 'デジタルで整えたフォルム',
        craft: '手仕上げの表面',
        warranty: 'アフターケア対応'
      },
      size: 'サイズ',
      addToCart: 'カートに追加',
      relatedProducts: '関連商品',
      productFeatures: {
        shipping: { title: '送料無料', desc: '全国配送に対応' },
        returns: { title: '7日間返品', desc: 'シンプルな返品手続き' },
        authentic: { title: 'スターリングシルバー', desc: '925シルバー素材' }
      }
    },
    // ショッピングカート
    cart: {
      title: 'ショッピングカート',
      empty: 'カートは空です',
      continueShopping: '買い物を続ける',
      checkout: 'お会計へ',
      total: '合計',
      quantity: '数量',
      remove: '削除',
      successAdded: 'カートに追加されました！',
      viewCart: 'カートを見る'
    }
  }
};
